module.exports = {
  // eslint-disable-next-line prettier/prettier
  baseUrl: process.env.VUE_APP_BASE_URL || ' https://iig-chat-api-uat.herokuapp.com',
  pusherId: process.env.VUE_APP_PUSHER_ID || '58dca7bf42331f09b2b6',
  cluster: process.env.VUE_APP_AUTH_CLUSTER || 'mt1',
  checksurveyexpireEndpoint: process.env.VUE_APP_CHECK_SURVEY_EXPIRE_ENDPOINT ||'/webchat/checksurveyexpire',
}
 //test